<mat-drawer-container
  class="drawer-container presenter-elements-sidenav"
  [hasBackdrop]="collapseMenu$ | async"
  fullscreen
>
  <mat-drawer
    #elementsDrawer
    [mode]="(mode$ | async) || 'push'"
    [opened]="(collapseMenu$ | async) === false"
    class="menu-container"
    position="start"
  >
    <div class="header-container">
      <ng-content select="[header]"></ng-content>
    </div>
    <ng-content select="[list]"></ng-content>

    <div class="elements-container"></div>
  </mat-drawer>

  <mat-drawer-content class="drawer-content">
    @if (!elementsDrawer.opened) {
      <button class="sidenav-toggle-button" mat-fab (click)="elementsDrawer.toggle()">
        <gb-icon icon="add"> </gb-icon>
      </button>
    }
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
